export const SUPPORTED_LOCALES = ['zh-CN', 'en-US', 'ja-JP'] as const

export type UiLocale = (typeof SUPPORTED_LOCALES)[number]

export type LocaleMenuItem = {
  code: UiLocale
  nativeName: '中文' | 'English' | '日本語'
}

export const LOCALE_MENU_ITEMS: readonly LocaleMenuItem[] = [
  { code: 'zh-CN', nativeName: '中文' },
  { code: 'en-US', nativeName: 'English' },
  { code: 'ja-JP', nativeName: '日本語' },
] as const

export const DEFAULT_LOCALE: UiLocale = 'en-US'

export const LOCALE_STORAGE_KEY = 'imockup.ui.locale'
